module.exports = ":host {\r\n    z-index: 4;\r\n}"